import { useCallback } from "react";
import { useTranslate } from "react-admin";

export const useAppT = () => {
  const translate = useTranslate();
  return useCallback(
    (key: string, options?: Record<string, unknown>) =>
      translate(`app.${key}`, options),
    [translate],
  );
};

export const useCommonLabels = () => {
  const t = useAppT();
  return {
    search: t("common.search"),
    status: t("common.status"),
    active: t("common.active"),
    inactive: t("common.inactive"),
    type: t("common.type"),
    level: t("common.level"),
    phrase: t("common.phrase"),
    filename: t("common.filename"),
    image: t("common.image"),
    background: t("common.background"),
    textColor: t("common.textColor"),
    upload: t("common.upload"),
    replace: t("common.replace"),
    uploading: t("common.uploading"),
    delete: t("common.delete"),
    noFile: t("common.noFile"),
    fileUploaded: t("common.fileUploaded"),
    uploadError: t("common.uploadError"),
    fileUploadHint: t("common.fileUploadHint"),
    requiredField: t("common.requiredField"),
    userId: t("common.userId"),
    createdAt: t("common.createdAt"),
  };
};

export const useFieldLabels = () => {
  const t = useAppT();
  return {
    phraseAz: t("fields.phraseAz"),
    phraseRu: t("fields.phraseRu"),
    phraseEn: t("fields.phraseEn"),
    titleAz: t("fields.titleAz"),
    titleRu: t("fields.titleRu"),
    titleEn: t("fields.titleEn"),
    descriptionAz: t("fields.descriptionAz"),
    descriptionRu: t("fields.descriptionRu"),
    descriptionEn: t("fields.descriptionEn"),
    emotionInsight: t("fields.emotionInsight"),
    preventionPlan: t("fields.preventionPlan"),
    alternativeResponse: t("fields.alternativeResponse"),
  };
};
